define('modules/form_editor/behaviours/has_uploader',['require','exports','module','fineuploader','env','services/auth','common/views/alert_view','lib/clipboard'],function(require, exports, module){
  "use strict";

  var qq = require("fineuploader");

  var config = require("env"),
    Auth = require('services/auth'),
    authInfo = Auth.getAuthInfo(),
    AlertView = require("common/views/alert_view"),
    clipboard = require("lib/clipboard");

  module.exports = {
   _setupUploader: function(){
     var self = this;
     if (this.uploader) {
       try {
         this.uploader.fineUploader("reset");
         return;
       } catch(e) {}
     }
     this.uploader = this.$(".js-browse").fineUploader({
       autoUpload: true,
       uploaderType: "basic",
       button: this.$(".js-browse"),
       request: {
         endpoint: config.apiHost + "/files",
         customHeaders: {
           "Authorization": "Bearer " + authInfo.getAccessToken()
         },
         params: {
           pages_id: this.options.pages_id,
           variants_id: this.options.variants_id,
           platform: this.options.platform,
           type: "terms"
         },
       },
       cors: {
         allowXdr: true,
         expected: true
       },
       validation: {
         acceptFiles: ".htm,.html",
         allowedExtensions: ["htm", "html"]
       }
     })
       .on("submit", function(e, id, name){
         //remove error and button class if there is any
         var message = $.i18n.t("formEditor.uploadingHTML");
         self._showAlert(true, message, true);
       })
       .on("complete", function(e, id, name, response){
         if(response.success){
           var newURL = "/resources/" + response.id;
           var markdownLink = "[" + response.originalFileName + "]("+ newURL +")";
           var uploadedMessage = $.i18n.t("formEditor.uploadedHTML");
           var message = '<span>' + uploadedMessage + ':</span>' +
             '<p><a href="javascript:void(0);">' +
             '<span class="ed-icon ed-icon-duplicate"></span>' +
             '<span>' + newURL + '</span></a></p>';
           self._showAlert(true, message, false, function(e) {
             clipboard(markdownLink);
           });
         }
       })
       .on("error", function(e, id, name, errorReason, jqXHR){
         var message = $.i18n.t("formEditor.errorUploadingHTML");
         self._showAlert(false, message, false);
       });
   },
    _showAlert: function(success, message, autoHide, onHide){
      AlertView.showAlert({
        message: message,
        escapeMessage: false,
        alertType: success ? "success": "danger",
        autoHide: autoHide,
        onHide: onHide
      });
    }

  };
});

